const productFeatureEl = document.getElementById("product-feature");
const prevButton = document.getElementById("product-feature-prev");
const nextButton = document.getElementById("product-feature-next");
const featureCounter = document.getElementById("product-feature-slide-count");
const features =
    productFeatureEl?.querySelectorAll("[data-feature-slide]") || [];
let pins = [];
let activeFeature = 0;

export function initProductFeature() {
    if (!productFeatureEl) {
        return;
    }

    nextButton?.addEventListener("click", nextFeature);
    prevButton?.addEventListener("click", prevFeature);

    //createPins();

    const resizeObserver = new ResizeObserver(() => onResize());
    resizeObserver.observe(productFeatureEl);
}

function onResize() {
    removePins();
    //createPins();
}

function activateFeature(index) {
    features.forEach((feature) => {
        feature.classList.remove("active");
    });

    features[index]?.classList.add("active");
    activeFeature = index;

    pins.forEach((pin, pinIndex) => {
        pin.classList.remove("active", pinIndex === index);
    });
    pins[index]?.classList.add("active");

    if (featureCounter) {
        featureCounter.innerHTML = index + 1;
    }
}

function nextFeature(e) {
    e && e.preventDefault();
    activateFeature((activeFeature + 1) % features.length);
}

function prevFeature(e) {
    e && e.preventDefault();

    if (activeFeature === 0) {
        activateFeature(features.length - 1);
    } else {
        activateFeature(activeFeature - 1);
    }
}

function removePins() {
    const pinHolder = document.getElementById("product-feature-holder");
    if (!pinHolder) {
        return;
    }

    pins.forEach((pin) => {
        pinHolder.removeChild(pin);
    });
    pins = [];
}

function createPins() {
    const pinHolder = document.getElementById("product-feature-holder");
    if (!pinHolder) {
        return;
    }

    const holderWidth = pinHolder.offsetWidth;

    features.forEach((feature, index) => {
        const top = feature.dataset.featureY || "0";
        const left = feature.dataset.featureX || "0";
        const pin = document.createElement("div");

        pin.classList.add("product-feature-pin");
        if (Number(left) < 50) {
            pin.classList.add("product-feature-pin-right");
            pin.style.setProperty(
                "--offset-x",
                `${(Number(left) / 100) * holderWidth}px`,
            );
        } else {
            pin.style.setProperty(
                "--offset-x",
                `${((100 - Number(left)) / 100) * holderWidth}px`,
            );
        }
        pin.innerHTML = `<div class="product-feature-pin-handle">${index + 1}</div>`;
        pin.style.setProperty("--top", `${top}%`);
        pin.style.setProperty("--left", `${left}%`);
        if (index === activeFeature) {
            pin.classList.add("active");
        }
        pin.addEventListener("click", () => activateFeature(index));
        pinHolder.appendChild(pin);
        pins.push(pin);
    });
}
